import { render } from "./AddHistoryModal.vue?vue&type=template&id=a22d2294&scoped=true"
import script from "./AddHistoryModal.vue?vue&type=script&lang=js"
export * from "./AddHistoryModal.vue?vue&type=script&lang=js"

import "./AddHistoryModal.vue?vue&type=style&index=0&id=a22d2294&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a22d2294"]])

export default __exports__